import { Link } from '@tanstack/react-router';
import React from 'react';
import { MydraLogo } from '../MydraLogo';
import { UserMenu } from './components/UserMenu';

type NavBarProps = React.HTMLAttributes<HTMLDivElement> & {
  beforeLogo?: React.ReactNode;
  afterLogo: React.ReactNode;
  beforeUserMenu?: React.ReactNode;
  showUserMenu?: boolean;
};

export function NavBar({
  beforeLogo,
  afterLogo,
  beforeUserMenu,
  showUserMenu,
  ...props
}: NavBarProps) {
  return (
    <header
      {...props}
      className={`${props.className ?? ''} flex justify-between pl-8 px-6 py-3 min-h-16 z-40 bg-white border-b items-center`}
    >
      <div className="flex items-center">
        {beforeLogo}
        <Link to="/">
          <MydraLogo className="h-8 w-fit" />
        </Link>
        <div className="ml-8">{afterLogo}</div>
      </div>
      <div className="flex items-center gap-11">
        {beforeUserMenu}
        {showUserMenu && <UserMenu />}
      </div>
    </header>
  );
}
